import { Component, Input } from '@angular/core';
import { ArgyleIncomeStream } from '../models/argyle';

@Component({
  selector: 'app-income-ver-w2-card',
  templateUrl: './income-ver-w2-card.component.html',
  styleUrls: ['./income-ver-w2-card.component.less']
})
export class IncomeVerW2CardComponent {
  @Input() incomeData : ArgyleIncomeStream;
}
